---
meta:
  - title: Personalizar la redacción - IUSPRO Docs
  - description: Aprende a personalizar la redacción de documentos.
---

# Personalizar la redacción con "Mis Formatos"

La función "Mis Formatos" le permite personalizar cómo el Redactor crea sus documentos según sus necesidades o las de su
firma.

## ¿Para qué sirve "Mis Formatos"?

Por defecto, la IA hace lo que dice la ley. Pero si usted o su firma tienen guías específicas de cómo redactar ciertos
documentos, puede crear formatos personalizados.

## ¿Cuándo crear un formato?

Cuando necesita que ciertos documentos:

- Incluyan cláusulas específicas
- Tengan un tono particular
- Sigan un formato específico de su firma
- Incluyan secciones adicionales en cierto orden
- Mencionen a ciertas personas o instituciones

## Como crear un formato

1. **Vaya a "Mis Formatos"**
2. **Cree un nuevo formato**
3. **Dele un nombre descriptivo**, por ejemplo: "Demandas de menores de edad"
4. **Escriba las instrucciones** de cómo quiere que se redacte ese tipo de documento

### Opciones al crear un formato

Puede hacerlo de tres formas:

#### Opción 1: Escribir instrucciones

Escriba en texto qué quiere que haga. Por ejemplo:

- "Quiero incluir una sección tal, después de tal otra sección"
- "Para menores de edad, incluir cláusulas específicas que mencionen a..."
- "Usar un tono más formal/informal"
- "Al citar resoluciones, usar este formato específico"

#### Opción 2: Subir un archivo de guía

- Suba un documento que tenga su guía
- Puede ser en PDF o Word
- Puede ser tan largo o corto como necesite
- Puede ser tan específico o general como quiera

#### Opción 3: Usar un Word como plantilla visual

Si quiere conservar la presentación de un documento de su despacho:

1. Suba el archivo `.docx` al Formato
2. Seleccione **Usar como plantilla** junto al archivo
3. Use ese Formato al crear el documento en Redactor

IusPro empezará desde ese Word e intentará conservar su estructura visual: encabezados, pies de página, márgenes,
tablas, logos, marcas de agua y estilos. La IA modifica una copia de la plantilla; el archivo original no cambia.

Si solo quiere aplicar el mismo membrete o diseño al momento de descargar documentos distintos, use una
[plantilla de Word para exportar](/guias/configuracion-plantillas-word). Esta opción no cambia cómo redacta la IA.

## Usar un formato al redactar

Cuando vaya a crear un nuevo documento:

1. Haga clic en "Nuevo documento"
2. Arriba verá "Elegir un formato"
3. Seleccione el formato que quiere usar
4. El Redactor seguirá esas instrucciones al crear el documento

## Importante: Diferencia entre formato y requisitos legales

- **Los requisitos legales** los busca el Redactor en los códigos automáticamente
- **El formato** es para cosas más personalizadas que son preferencia suya o de su firma

Por ejemplo:

- El Redactor ya sabe qué debe incluir una demanda según la ley
- El formato le dice cómo usted prefiere organizarla o qué estilo usar

## Compartir formatos

Los formatos se pueden compartir con otros usuarios de su firma para que todos redacten de forma consistente.
